import template from "./settings-taxes.html";

const SettingsTaxesComponent = {
  template: template,
  controller: class SettingsTaxesController {
    /* @ngInject */
    constructor($rootScope, Tax) {
      this.$rootScope = $rootScope;
      this.Tax = Tax;
    }

    $onInit() {
      this.newTax = null;
    }

    add() {
      if (this.newTax === null) this.newTax = new this.Tax();
    }

    cancelNewTax() {
      this.newTax = null;
    }
  },
};

export default SettingsTaxesComponent;
